export default __webpack_public_path__ + "static/media/hawaii.b72d72eb.svg";